import type { Location } from '@virginexperiencedays/products';

/**
 * @param locations
 * @returns a dictionary containing locations grouped by region
 */
export const reduce = (locations: Location[] = []) => {
  if (!locations) return {};

  return locations.reduce((regions, location) => {
    try {
      const region = location?.region;

      if (!region || region === 'Uncategorized') return regions;

      // Convert latitude and longitude to numbers and check for validity
      const lat = Number(location.lat);
      const lng = Number(location.lng);

      if (isNaN(lat) || isNaN(lng)) {
        console.error(`Invalid latitude or longitude for location: ${location.name}`);
        return regions;
      }

      // Initialize the region if it doesn't exist
      if (!regions[region]) {
        regions[region] = [];
      }

      // Add the location to the corresponding region
      regions[region].push({ ...location, lat, lng });
    } catch (error) {
      console.error(`Error processing location: ${location?.name || 'Unknown'}`, error);
    }
    return regions;
  }, {} as Record<string, Location[]>);
};
